import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'is-stackedbar',
  templateUrl: './stackedbar.component.html',
  styleUrls: ['./stackedbar.component.scss'],
})
export class StackedbarComponent {
  constructor(private cd: ChangeDetectorRef) {}

  //Array that contains all info for svg bars
  stacked: Array<StackedBar> = [];

  private _title = '';

  @Input() set title(val: string) {
    this._title = val;
  }

  get title() {
    return this._title;
  }

  public _usedKeys: LegendItem[] = [];
  private _defaultUsedKeys: LegendItem[] = [];

  public defaultColors = [
    'rgb(160, 209, 255)',
    'rgb(247, 168, 10)',
    'rgb(243, 235, 143)',
    'green',
    'purple',
  ];

  private _minX = 0;
  private _maxX = 0;

  private _minY = 0;
  private _maxY = 0;

  @Input() set data(d: any) {
    if (d) {
      this._usedKeys = [];
      const keys = Object.keys(d).map((key) => Number(key));
      const values: any[] = Object.values(d);

      // smallest value x
      if (keys.length) {
        this._minX = keys.reduce((prev: number, cur: number) => {
          return prev < cur ? prev : cur;
        });

        // largest value x
        this._maxX = keys.reduce((prev: number, cur: number) => {
          return prev > cur ? prev : cur;
        });
      }

      // calculate total of stack

      const totalStacks = values.map((v: any) => {
        return (Object.values(v) as number[]).reduce(
          (prev: number, cur: number) => {
            return cur + prev;
          }
        );
      });

      // smallest yValue
      if (totalStacks.length) {
        this._minY = totalStacks.reduce((prev: number, cur: number) => {
          return prev < cur ? prev : cur;
        });

        // largest yValue
        this._maxY = totalStacks.reduce((prev: number, cur: number) => {
          return prev > cur ? prev : cur;
        });
      }

      // trace unique keys (if not given)
      if (!this._defaultUsedKeys.length) {
        values.map((keys) =>
          Object.keys(keys).map((k) => {
            if (!this._usedKeys.map((u) => u.description).includes(k)) {
              this._usedKeys.push({
                description: k,
                color:
                  this.defaultColors[
                    this._usedKeys.length % this.defaultColors.length
                  ],
              });
            }
          })
        );
      }

      // Maak stackedbar leeg
      this.stacked = [];

      for (let i = 0; i <= this._maxX; i++) {
        if (keys.includes(i)) {
          this.stacked.push(
            new StackedBar(
              Object.values(d[i]),
              i,
              this._minX,
              this._maxX,
              this._minY,
              this._maxY
            )
          );
        }
      }

      this.cd.detectChanges();
      this._data = d;
    }
  }

  private _data: any = [];

  get data() {
    return this._data;
  }
}

export class StackedBar {
  total: number = 0;
  bars: Bar[] = [];

  constructor(
    private vals: number[],
    private position: number,
    private minX: number,
    private maxX: number,
    private minY: number,
    private maxY: number
  ) {
    this.total = this.vals.reduce((prev: number, cur: number) => {
      return prev + cur;
    });

    let used = 0;

    this.bars = Object.values(vals).map((v: number) => {
      used += v;
      return new Bar(v, used, this.total);
    });
  }

  getX() {
    return (100 * (this.position / (this.maxX + 1))).toString() + '%';
  }

  getWidth() {
    return (100 * (1 / (this.maxX + 1))).toString() + '%';
  }

  getHeight() {
    if (this.maxY != 0) {
      return (100 * (this.total / this.maxY)).toString() + '%';
    }
    return '100%';
  }

  getY() {
    if (this.maxY != 0) {
      return (100 * ((this.maxY - this.total) / this.maxY)).toString() + '%';
    }
    return '100%';
  }
}

class LegendItem {
  description = '';
  color = '';
}

class Bar {
  constructor(
    private value: number,
    private used: number,
    private total: number
  ) {}

  getTop() {
    if (this.total != 0) {
      return ((100 * (this.total - this.used)) / this.total).toString() + '%';
    }
    return '100%';
  }

  getPercentage() {
    if (this.total != 0) {
      return (100 * (this.value / this.total)).toString() + '%';
    }
    return '100%';
  }
}
